import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import Slider from 'react-slick';
import { setOaName, getOas } from '../../actions';


// Card de cidades
function Cities(props) {
  function handleOaClick(city) {
    props.setOaName(city);
    props.getOas();
  }

  return (
    <div className="cities">
      <Slider
        dots
        infinite
        speed={300}
        autoplaySpeed={3000}
        variableWidth
        slidesToShow={1}
        slidesToScroll={1}
        autoplay
      >
        {props.cities.map((city) => (
          <div className="city-block" key={Math.random()}>
            <p className="city-name">
              {city.city}
              ,
              {city.uf}
            </p>
            <Link to="/oa">
              <button className="btn btn-primary" onClick={() => handleOaClick(city.city)} type="button">

                VER ATIVIDADES

              </button>
            </Link>
          </div>
        ))}
      </Slider>
    </div>
  );
}

const mapStateToProps = (store) => ({
  cities: store.filterState.cities,
});
const mapDispatchToProps = (dispatch) => bindActionCreators({ setOaName, getOas }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Cities);
